import { SuggestionType } from "enum";

export interface SuggestionTypeLike {
  SuggestionType?: unknown;
  SuggestionTypeDescription?: unknown;
  Tipo?: unknown;
  TipoDescricao?: unknown;
}

export const normalizeSuggestionType = (value: unknown): string =>
  typeof value === "string"
    ? value
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    : "";

const suggestionTypeKeys = {
  purchaseOrder: SuggestionType.PurchaseOrder.toString(),
  transferOrder: SuggestionType.TransferOrder.toString(),
  returnableAssetsPurchaseOrder: SuggestionType.ReturnableAssetsPurchaseOrder.toString(),
  stockReturn: SuggestionType.StockReturn.toString(),
} as const;

const suggestionTypeAliases: Record<string, string> = {
  "1": suggestionTypeKeys.purchaseOrder,
  po: suggestionTypeKeys.purchaseOrder,
  pc: suggestionTypeKeys.purchaseOrder,
  "purchase order": suggestionTypeKeys.purchaseOrder,
  "pedido de compra": suggestionTypeKeys.purchaseOrder,
  "2": suggestionTypeKeys.transferOrder,
  to: suggestionTypeKeys.transferOrder,
  pt: suggestionTypeKeys.transferOrder,
  "transfer order": suggestionTypeKeys.transferOrder,
  "pedido de transferencia": suggestionTypeKeys.transferOrder,
  "pedido de transferência": suggestionTypeKeys.transferOrder,
  "3": suggestionTypeKeys.returnableAssetsPurchaseOrder,
  poa: suggestionTypeKeys.returnableAssetsPurchaseOrder,
  pa: suggestionTypeKeys.returnableAssetsPurchaseOrder,
  "returnable assets purchase order": suggestionTypeKeys.returnableAssetsPurchaseOrder,
  "4": suggestionTypeKeys.stockReturn,
  sr: suggestionTypeKeys.stockReturn,
  re: suggestionTypeKeys.stockReturn,
  ds: suggestionTypeKeys.stockReturn,
  "stock return": suggestionTypeKeys.stockReturn,
  "retorno de estoque": suggestionTypeKeys.stockReturn,
  "devolucion de stock": suggestionTypeKeys.stockReturn,
};

const getSuggestionTypeKeyFromValue = (value: unknown): string => {
  if (typeof value === "number") {
    return Number.isInteger(value) ? suggestionTypeAliases[String(value)] || "" : "";
  }

  if (typeof value !== "string") return "";

  const normalizedValue = normalizeSuggestionType(value);
  return suggestionTypeAliases[normalizedValue] || "";
};

export const getSuggestionTypeKey = (suggestion?: SuggestionTypeLike | null): string => {
  const typeKey = getSuggestionTypeKeyFromValue(suggestion?.SuggestionType ?? suggestion?.Tipo);
  if (typeKey) return typeKey;

  const description = normalizeSuggestionType(
    suggestion?.SuggestionTypeDescription ?? suggestion?.TipoDescricao
  );
  if (description) return suggestionTypeAliases[description] || description;

  return "";
};

export const isStockReturnSuggestion = (
  suggestion?: SuggestionTypeLike | null
): boolean =>
  getSuggestionTypeKey(suggestion) === suggestionTypeKeys.stockReturn;

export const getStockReturnSuggestions = <T extends SuggestionTypeLike>(
  suggestions: T[] = []
): T[] => suggestions.filter(isStockReturnSuggestion);

export const getOtherSuggestions = <T extends SuggestionTypeLike>(
  suggestions: T[] = []
): T[] => suggestions.filter((suggestion) => !isStockReturnSuggestion(suggestion));
